import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🗂️',
  number: '01',
  title: 'Wybierzcie projekt',
  description: 'Według wieku dziecka, wolnego czasu i poziomu trudności.'
}, {
  icon: '🧰',
  number: '02',
  title: 'Przygotujcie proste materiały',
  description: 'Lista jest na początku karty, razem z podpowiedziami zamienników.'
}, {
  icon: '🚀',
  number: '03',
  title: 'Budujcie, testujcie, ulepszajcie',
  description: 'Obrazkowe kroki, wyjaśnienie „dlaczego to działa” i kolejne wyzwanie.'
}];
export function HowItWorks() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-139" data-mp="cqwz37h6288r">
      <div className="mx-auto max-w-5xl" data-id="element-140" data-mp="gtbhjqgxb5zi">
        <div className="mx-auto max-w-2xl text-center" data-id="element-141" data-mp="gs8q9hfov1j2">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-142" data-mp="14je7o11a21vh">
            Jak to działa
          </h2>
          <p className="mt-3 text-sm text-foreground/70 sm:text-base" data-id="element-143" data-mp="19anteqjpgl23">
            Łatwo zacząć. Szkoda kończyć.
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-144" data-mp="2rjbgp1yeoglv">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-145" data-mp="31b7hikrvmkts" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-146" data-mp="31c933j6iqppr">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-primary/20 bg-card text-3xl" data-id="element-147" data-mp="36cwsy1j0h0ie">
                  {step.icon}
                </span>
                <span className="mt-4 font-display text-2xl font-bold text-primary" data-id="element-148" data-mp="3f95tjjiq6564">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-foreground" data-id="element-149" data-mp="1kxr310hw41pb">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground/70" data-id="element-150" data-mp="3kzqlux81nr0z">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-primary/25 md:hidden" aria-hidden="true" data-id="element-151" data-mp="3tzne18tn780s" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}